module.exports = __webpack_public_path__ + "img/ICRA_2025.fd0c96dc.png";